<template>
  <form class="chat-input" @submit.prevent="submit">
    <div v-if="error" class="chat-input__error" role="alert">{{ error }}</div>

    <div class="chat-input__row">
      <textarea
        ref="textarea"
        v-model="draft"
        class="chat-input__textarea"
        rows="1"
        :maxlength="maxLength"
        :disabled="isLoading"
        placeholder="Ask about underutilized sites or expiring leases..."
        aria-label="Type your question"
        @keydown="handleKeydown"
        @input="autoResize"
      ></textarea>

      <button
        type="submit"
        class="chat-input__send"
        :disabled="!canSend"
        aria-label="Send message"
      >
        <theme-icon
          :icon="isLoading ? 'loading' : 'arrow-up'"
          type="icons"
          :classes="isLoading ? 'w-4 h-4 animate-spin' : 'w-4 h-4'"
        />
      </button>
    </div>

    <div class="chat-input__meta">
      <span>{{ draft.length }} / {{ maxLength }}</span>
      <span class="chat-input__hint">Enter to send · Shift+Enter for newline</span>
    </div>
  </form>
</template>

<script>
/**
 * Composer for the chatbot. Auto-resizes up to 4 rows, throttles via the
 * Vuex `isLoading` flag (the store ignores duplicate sends anyway), and
 * surfaces the latest backend error directly above the textarea.
 */
export default {
  name: 'ChatInput',

  data() {
    return {
      draft: '',
      maxLength: 1000,
      maxRows: 4,
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.chat.isLoading;
    },
    error() {
      return this.$store.state.chat.error;
    },
    canSend() {
      return !this.isLoading && this.draft.trim().length > 0;
    },
  },

  methods: {
    async submit() {
      if (!this.canSend) return;
      const message = this.draft;
      this.draft = '';
      this.$nextTick(() => this.autoResize());
      await this.$store.dispatch('chat/sendMessage', message);
    },

    handleKeydown(e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        this.submit();
      }
    },

    autoResize() {
      const el = this.$refs.textarea;
      if (!el) return;
      el.style.height = 'auto';
      // Cap at maxRows * line height — roughly 24px per row in this theme.
      const max = this.maxRows * 24 + 16;
      el.style.height = Math.min(el.scrollHeight, max) + 'px';
    },
  },
};
</script>
